import { render, staticRenderFns } from "./DashboardAdminHanes.vue?vue&type=template&id=6c09cec3&scoped=true&"
import script from "./DashboardAdminHanes.vue?vue&type=script&lang=js&"
export * from "./DashboardAdminHanes.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAdminHanes.vue?vue&type=style&index=0&id=6c09cec3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c09cec3",
  null
  
)

export default component.exports